import React, { Component } from 'react';
import { connect } from 'react-redux';
import BrandProductListModal from '../../../../views/app/common/modal/BrandProductListModal';
import { appActions } from '../../../../store/modules/app';
import withModal from '../../../../lib/hoc/withModal';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';

class BrandProductListModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      storeId: this.props.data.storeId,
      productStatusList: this.props.data.productStatusList,
    };
  }

  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { storeId, productStatusList } = this.state;

    this.getList({
      storeId,
      productStatusList,
      pagination: LIST_PAGINATION_MODEL,
    });
  };

  /**
   * 리스트 불러오기
   */
  getList = (option) => {
    const { getBrandProductList, data } = this.props;
    const { storeId, productStatusList } = this.state;
    const { pagination } = data.listData;

    getBrandProductList({
      storeId,
      productStatusList,
      pagination,
      ...option,
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'brandProductListModal', value: false });
  };

  render() {
    return (
      <BrandProductListModal {...this.props} {...this.state} getList={this.getList} closeModal={this.closeModal} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.brandProductListModal.isOpen,
    data: state.app.brandProductListModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: appActions.appToggleModal,
  getBrandProductList: appActions.getBrandProductList,
  getProductSubCategoryList: appActions.getProductSubCategoryList,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(BrandProductListModalContainer));
